import React from 'react';
import Media from 'react-media';
import { connect } from 'react-redux';
import { FEATURE_DEPOSIT_PROMO } from '../../../config/features';
import CycleCardDesktop from './CycleCardDesktop';
import CycleCardMobile from './CycleCardMobile';
import { CycleCardProps } from '../types';
import { themes, ReduxState } from 'kb-shared';
const { breakpoints } = themes;

const CycleCard = (props: CycleCardProps) => {
  const { cycle, onSelect, selected, selectedCycleType, depositPromoCode } = props;

  return (
    <Media query={{ minWidth: breakpoints.raw.largePhonePortrait }}>
      {desktop => {
        if (desktop) {
          return (
            <CycleCardDesktop
              cycle={cycle}
              onSelect={cyc => {
                onSelect(cyc);
              }}
              selected={selected}
              selectedCycleType={selectedCycleType}
              depositPromoCode={depositPromoCode}
            />
          );
        }
        return (
          <CycleCardMobile
            cycle={cycle}
            onSelect={cyc => {
              onSelect(cyc);
            }}
            selected={selected}
            selectedCycleType={selectedCycleType}
            depositPromoCode={depositPromoCode}
          />
        );
      }}
    </Media>
  );
};

const mapStateToProps = (state: ReduxState) => {
  return {
    depositPromoCode: state.features.features[FEATURE_DEPOSIT_PROMO]
  };
};
export default connect(mapStateToProps)(CycleCard);
